import type { CityConfig } from "../city-template/types";

export const suffolkVaConfig: CityConfig = {
  city: "Suffolk",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "suffolk-va",
  route: "/cities/suffolk-va",
  title: "Emergency Passport Suffolk VA | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Suffolk, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Suffolk, Isle of Wight County, and the western Hampton Roads region. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Suffolk, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from Suffolk, Isle of Wight County, or the western Hampton Roads region? We help Suffolk travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Suffolk%20Virginia%20rural%20countryside%20with%20rolling%20farmland%2C%20the%20historic%20downtown%20Suffolk%20district%20with%20Victorian%20architecture%20and%20peanut%20warehouse%20district%2C%20the%20Nansemond%20River%20and%20Great%20Dismal%20Swamp%20wildlife%20refuge%20visible%20in%20the%20background%2C%20warm%20sunset%20light%20over%20rural%20Hampton%20Roads%20with%20pine%20forests%20and%20coastal%20plains%2C%20professional%20photography%20showcasing%20Virginias%20largest%20city%20by%20land%20area%20with%20southern%20charm%20and%20rural%20beauty%2C%20no%20people%20visible%2C%20scenic%20rural%20landscape&width=1800&height=700&seq=suffolk-va-hero-001&orientation=landscape",
  heroImageAlt: "Suffolk Virginia rural countryside with historic downtown, peanut warehouses, and the Nansemond River",
  geoPosition: "36.7282;-76.5836",
  geoPlacename: "Suffolk, Virginia",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 200 miles north of Suffolk via I-95",
  },
  nearbyCitiesZips: [
    { name: "Suffolk", zips: "23432, 23433, 23434, 23435, 23436, 23437, 23438, 23439" },
    { name: "Isle of Wight County", zips: "23430, 23487, 23488, 23851, 23898" },
    { name: "Smithfield", zips: "23430, 23431" },
    { name: "Franklin", zips: "23851" },
    { name: "Chesapeake", zips: "23320, 23321, 23322, 23323, 23324, 23325, 23326, 23327, 23328" },
    { name: "Virginia Beach", zips: "23450, 23451, 23452, 23453, 23454, 23455, 23456, 23457, 23458, 23459, 23460, 23461, 23462, 23463, 23464, 23465, 23466, 23467, 23468, 23471, 23479" },
    { name: "Portsmouth", zips: "23701, 23702, 23703, 23704, 23705, 23707, 23708, 23709" },
    { name: "Norfolk", zips: "23501, 23502, 23503, 23504, 23505, 23506, 23507, 23508, 23509, 23510, 23511, 23513, 23514, 23515, 23517, 23518, 23519, 23520, 23523, 23529, 23541, 23551" },
    { name: "Newport News", zips: "23601, 23602, 23603, 23605, 23606, 23607, 23608, 23609, 23612, 23628, 23630, 23661, 23662, 23663, 23664, 23665, 23666, 23668, 23669, 23681, 23693" },
    { name: "Hampton", zips: "23630, 23651, 23661, 23663, 23664, 23665, 23666, 23667, 23668, 23669, 23670, 23681" },
    { name: "Emporia", zips: "23847" },
    { name: "Southampton County", zips: "23827, 23828, 23829, 23837, 23844, 23851, 23866, 23874, 23878, 23887, 23898" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the Suffolk and Hampton Roads region" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Western Hampton Roads Hub", desc: "Serving Suffolk, Isle of Wight, Smithfield, and Franklin" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Virginia Beach passport services", route: "/cities/virginia-beach" },
    { name: "Chesapeake VA passport services", route: "/cities/chesapeake-va" },
    { name: "Norfolk VA passport services", route: "/cities/norfolk-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Suffolk remotely via secure courier. We do not have a walk-in office in Suffolk — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Suffolk and Hampton Roads travelers.",
  fpcOfficeDistance: "Serving all of Suffolk and the western Hampton Roads region including Isle of Wight County, Smithfield, Franklin, and Chesapeake",
  serviceAreaIntro: "From the rural peanut farms of Suffolk to the historic waterfront of Smithfield, from the quiet neighborhoods of Franklin to the expanding communities of northern Suffolk, from the shores of the Nansemond River to the edge of the Great Dismal Swamp, from the western reaches of Chesapeake to the southern Hampton Roads corridor — Fast Passport Center serves every corner of Suffolk and the surrounding Hampton Roads region. We regularly help travelers from Isle of Wight County, Smithfield, and Franklin get their passports fast.",
  nearbyCitiesIntro: "We serve all Suffolk neighborhoods and the western Hampton Roads region including Isle of Wight County, Smithfield, Franklin, Chesapeake, and the surrounding areas.",
  howItWorksIntro: "Most Suffolk travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Suffolk travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Suffolk and Hampton Roads travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Suffolk? Here are the most common ones we hear from Hampton Roads travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Suffolk international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Angela W.",
      location: "Suffolk, VA",
      rating: 5,
      text: "I live near the historic district of Suffolk and needed an emergency passport for a cruise to the Bahamas with 4 days notice. Fast Passport Center had my renewal in 3 days. I shipped from the UPS on Main Street and it was completely seamless. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "James L.",
      location: "Smithfield, VA",
      rating: 5,
      text: "As a Smithfield resident, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 5 days. The convenience for Isle of Wight families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Patricia M.",
      location: "Suffolk, VA",
      rating: 5,
      text: "First passports for my three grandchildren before a family trip to Jamaica. Fast Passport Center handled all the parental consent requirements perfectly and had all passports in 6 days. For Suffolk families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "William T.",
      location: "Franklin, VA",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to Toronto. I was in absolute panic. Fast Passport Center had a replacement in my hands in 48 hours. They saved my business trip. Western Hampton Roads professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "suffolk-va-1",
      name: "Suffolk Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Suffolk",
      state: "VA",
      zip: "23434",
      phone: "(757) 934-3101",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Suffolk",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Suffolk facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "suffolk-va-2",
      name: "Smithfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Smithfield",
      state: "VA",
      zip: "23430",
      phone: "(757) 357-5181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Smithfield, Isle of Wight County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Isle of Wight County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "suffolk-va-3",
      name: "Franklin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Franklin",
      state: "VA",
      zip: "23851",
      phone: "(757) 562-5181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Franklin, west of Suffolk",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Franklin and Southampton County. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "suffolk-va-4",
      name: "Chesapeake Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "Street address pending USPS listing",
      city: "Chesapeake",
      state: "VA",
      zip: "23320",
      phone: "(757) 547-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Chesapeake, east of Suffolk",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves eastern Suffolk and Chesapeake. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "suffolk-va-5",
      name: "Isle of Wight County Clerk",
      type: "County Clerk",
      address: "PO Box 80",
      city: "Isle of Wight",
      state: "VA",
      zip: "23397",
      phone: "(757) 365-6200",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Isle of Wight County",
      website: "https://www.co.isle-of-wight.va.us",
      websiteLabel: "Isle of Wight Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
    {
      id: "suffolk-va-6",
      name: "Suffolk City Clerk",
      type: "City Clerk",
      address: "PO Box 1608",
      city: "Suffolk",
      state: "VA",
      zip: "23439",
      phone: "(757) 514-4010",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Suffolk City",
      website: "https://www.suffolkva.us",
      websiteLabel: "Suffolk City Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3+ hour drive to DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Suffolk photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hampton Roads acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Suffolk applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Suffolk families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Suffolk travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Suffolk or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Suffolk address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Suffolk before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Suffolk for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the western Hampton Roads region." },
    { q: "How fast can I renew my passport in Suffolk?", a: "Fast Passport Center offers fast passport renewal in Suffolk in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Suffolk?", a: "The nearest regional passport agency to Suffolk is the Washington Passport Agency, located approximately 200 miles north in downtown Washington, DC via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Suffolk." },
    { q: "Can I get a same-day passport appointment near Suffolk?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Suffolk residents." },
    { q: "Can I expedite a child passport in Suffolk?", a: "Yes. Fast Passport Center expedites child passports in Suffolk for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Suffolk and Hampton Roads families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Suffolk with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Suffolk?", a: "With Fast Passport Center's emergency courier service, Suffolk travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Suffolk?", a: "Popular options include the Suffolk Main Post Office (23434), Smithfield Post Office (23430), Franklin Post Office (23851), and Chesapeake Post Office (23320). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Smithfield, Franklin, or Isle of Wight County?", a: "We serve the entire Hampton Roads region including Smithfield, Franklin, Isle of Wight County, and Southampton County. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Suffolk?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Suffolk", address: "1203 N Main St, Suffolk, VA 23434", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Suffolk", address: "624 N Main St, Suffolk, VA 23434", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Smithfield", address: "1250 Benns Church Blvd, Smithfield, VA 23430", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Chesapeake", address: "1500 Cedar Rd, Chesapeake, VA 23322", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Franklin", address: "1340 Armory Dr, Franklin, VA 23851", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Hampton", address: "2003 W Mercury Blvd, Hampton, VA 23666", hours: "Mon-Sun: 7AM-11PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Suffolk",
      address: "1200 N Main St, Suffolk, VA 23434",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Chesapeake",
      address: "809 Greenbrier Pkwy, Chesapeake, VA 23320",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Portsmouth",
      address: "6400 Bickford Pkwy, Portsmouth, VA 23703",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves western Hampton Roads. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ORF",
      name: "Norfolk International Airport",
      distance: "Located approximately 25 miles east of Suffolk",
      address: "2200 Norview Ave, Norfolk, VA 23518",
      note: "The closest international airport to Suffolk. International and domestic flights. Accessible via US-13 and I-64.",
      flightUrl: "https://www.norfolkairport.com/",
      flightLabel: "ORF Airport",
      featured: true,
    },
    {
      code: "RIC",
      name: "Richmond International Airport",
      distance: "Located approximately 70 miles northwest of Suffolk",
      address: "1 Richard E. Byrd Terminal Dr, Richmond, VA 23250",
      note: "Regional hub for Central Virginia. Accessible via I-95.",
      flightUrl: "https://www.flyrichmond.com/",
      flightLabel: "RIC Airport",
      featured: false,
    },
    {
      code: "PHF",
      name: "Newport News/Williamsburg International Airport",
      distance: "Located approximately 30 miles north of Suffolk",
      address: "1000 Bland Blvd, Newport News, VA 23602",
      note: "Regional hub for the Virginia Peninsula. Accessible via I-64.",
      flightUrl: "https://www.flyphf.com/",
      flightLabel: "PHF Airport",
      featured: false,
    },
  ],
};